// extracted by mini-css-extract-plugin
module.exports = {"container":"vr3m7","content":"VPh+u","context":"uwbA0","divider":"H788z","footer":"Yrh9T"};